import axios from 'axios'

export const getCommittees = (clientId: string) => {
  return axios.get(`/committee/Committee/client/${clientId}`)
}

export const getCommitteeMembers = (id: string) => {
  return axios.get(`/committee/Committee/${id}/members`)
}

export const updateCommitteeMemberResponsibility = (
  groupId: string,
  assignmentId: number,
  value: string
) => {
  return axios.put(
    `/committee/Committee/${groupId}/assignment/${assignmentId}/responsibility`,
    { responsibility: value }
  )
}
